import { of } from 'rxjs';
import { actions } from '../../ducks/sending-request';

const { sendingRequest } = actions;

export const sendingRequestObservable = (sending) => of(sendingRequest(sending));
